import { FC } from 'react';

import { NON_BREAKING_SPACE } from 'utils/constants/common';
import { conversion } from 'utils/conversion';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    part1: 'campaign.targetings.ageRange.part1',
    part2: 'campaign.targetings.ageRange.part2',
    zero: 'campaign.targetings.ageRange.zero',
    one: 'campaign.targetings.ageRange.one',
    some: 'campaign.targetings.ageRange.some',
    many: 'campaign.targetings.ageRange.many',
};

const AgeRange: FC<{ age: number[] }> = ({ age }) => {
    const trls = useTrls();

    if (age.length === 0) {
        return null;
    }
    let message = trls(TrlKeys.part1, [age[0]]);

    if (age.length > 0) {
        message += ` ${trls(TrlKeys.part2)} `;
    }

    return (
        <section>
            {message}
            {age[age.length - 1]}
            {NON_BREAKING_SPACE}
            {conversion(age[age.length - 1], {
                zero: trls(TrlKeys.zero),
                one: trls(TrlKeys.one),
                some: trls(TrlKeys.some),
                many: trls(TrlKeys.many),
            })}
        </section>
    );
};

export default AgeRange;
